import { render, staticRenderFns } from "./OaCopyNumber.vue?vue&type=template&id=f94d805e&scoped=true"
import script from "./OaCopyNumber.vue?vue&type=script&lang=js"
export * from "./OaCopyNumber.vue?vue&type=script&lang=js"
import style0 from "./OaCopyNumber.vue?vue&type=style&index=0&id=f94d805e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94d805e",
  null
  
)

export default component.exports